// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X-WG","col":"styles_col__2RB0B"};